import React from 'react';
import { ArrowUpRight, Help } from '@saleshandy/icons';
import { WebhookTriggerEvent } from '../../../../../enums/webhook';
import Checkbox from '../../../../../../../shared/design-system/components/atoms/checkbox';
import { accessibleOnClick } from '../../../../../../../shared/utils/accessible-on-click';
import { supportUrls } from '../../../../../../../shared/utils/urls';
import {
  OverlayTooltip,
  Placement,
} from '../../../../../../../shared/design-system/components/overlay';

const events = [
  { label: 'When an email is sent', trigger: WebhookTriggerEvent.EmailSent },
  {
    label: 'When an email is opened',
    trigger: WebhookTriggerEvent.EmailOpened,
  },
  {
    label: 'When an email link is clicked',
    trigger: WebhookTriggerEvent.EmailLinkClicked,
  },
  {
    label: 'When a reply is received',
    trigger: WebhookTriggerEvent.ReplyReceived,
  },
  {
    label: 'When an email is bounced',
    trigger: WebhookTriggerEvent.EmailBounced,
  },
  {
    label: 'When a prospects is unsubscribed',
    trigger: WebhookTriggerEvent.ProspectUnsubscribed,
  },
  {
    label: 'When a prospect is finished',
    trigger: WebhookTriggerEvent.ProspectFinished,
  },
  {
    label: 'When a prospect outcome is changed',
    trigger: WebhookTriggerEvent.ProspectOutcomeUpdated,
  },
  {
    label: 'When a sequence is paused',
    trigger: WebhookTriggerEvent.SequencePaused,
  },
  {
    label: 'When an email account is disconnected',
    trigger: WebhookTriggerEvent.EmailAccountDisconnected,
  },
  {
    label: 'When the inbox radar test is completed',
    trigger: WebhookTriggerEvent.InboxAnalyserTestCompleted,
  },
  {
    label: 'When a task is created',
    trigger: WebhookTriggerEvent.TaskCreated,
    tooltip:
      'Triggers when any new task is created across LinkedIn, Call, Whatsapp or Custom channels.',
  },
  {
    label: 'When a LinkedIn task is updated',
    trigger: WebhookTriggerEvent.LinkedinTaskUpdated,
    tooltip: 'Triggers when a LinkedIn task is completed, skipped, or snoozed.',
  },
  {
    label: 'When a Call task is updated',
    trigger: WebhookTriggerEvent.CallTaskUpdated,
    tooltip: 'Triggers when a Call task is completed, skipped, or snoozed.',
  },
  {
    label: 'When a Whatsapp task is updated',
    trigger: WebhookTriggerEvent.WhatsAppTaskUpdated,
    tooltip: 'Triggers when a Whatsapp task is completed, skipped, or snoozed.',
  },
  {
    label: 'When a Custom task is updated',
    trigger: WebhookTriggerEvent.CustomTaskUpdated,
    tooltip: 'Triggers when a Custom task is completed, skipped, or snoozed.',
  },
  {
    label: 'When a bulk task action is performed',
    trigger: WebhookTriggerEvent.BulkTaskUpdated,
    tooltip:
      'Triggers when tasks are skipped or snoozed in bulk using bulk actions.',
  },
];

const EventToSendInput = ({ eventsToSend, onEventToSendChange }) => {
  const openExampleDataLink = () => {
    window.open(supportUrls.webhookExampleDataURL, '_blank');
  };

  return (
    <div className="event-to-send pdr-30">
      <div className="webhook-form-field">
        <div className="d-flex justify-content-between align-items-center">
          <div className="webhook-form-field-label justify-content-between">
            <p>Event to Send</p>
          </div>
          <div
            className="example-data-btn"
            {...accessibleOnClick(openExampleDataLink)}
          >
            <span>Example Data</span>
            <ArrowUpRight />
          </div>
        </div>
        <div className="events-container">
          {events.map((event) => (
            <div className="event">
              <Checkbox
                checked={eventsToSend.includes(event.trigger)}
                onChange={(checked) =>
                  onEventToSendChange(checked, event.trigger)
                }
                label={
                  <>
                    {event.label}
                    {event?.tooltip && (
                      <OverlayTooltip
                        className="webhook-url-tooltip"
                        placement={Placement.Right}
                        text={event.tooltip}
                      >
                        <div className="event-help-icon">
                          <Help />
                        </div>
                      </OverlayTooltip>
                    )}
                  </>
                }
              />
            </div>
          ))}
        </div>
        <p className="webhook-form-field-helper-text">
          Select the events that should trigger your webhook
        </p>
      </div>
    </div>
  );
};

export default EventToSendInput;
